var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3120334f7ce20dc15ddd1746751feafbcabee486"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["afterpay-site-next@touchcorp-ul"]={id:"3120334f7ce20dc15ddd1746751feafbcabee486"};
      